import { merchantPersonPhoneChallengeIdFormat } from "@redotech/redo-account-id";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const startLinkMerchantPhone = {
  name: "startLinkMerchantPhone" as const,
  input: z.object({ phone: z.string() }),
  output: z.object({
    alreadyLinked: z.boolean(),
    challengeId: merchantPersonPhoneChallengeIdFormat.schema.nullable(),
    phoneE164: z.string(),
    expiresAt: zExt.instant().nullable(),
  }),
};
